import { get, post, put, destroy } from "./base";

const BrandsServ = {
  index: (params) => get("/brands", { params }),
  single: (id) => get(`/brands/${id}`),
  create: (payload) => post("/brands", payload),
  update: (id, payload) => put(`/brands/${id}`, payload),
  remove: (id) => destroy(`/brands/${id}`),
  uploadImage: (formData) => post("/upload/brand", formData),
};

export default BrandsServ;
